import React from "react";
import { ProjectsInfo } from "../utils/resource.utils";
import ScrollAnimatedItem from "../utils/ScrollAnimatedItem";

const Projects = () => {
  return (
    <div className="relative isolate px-6 lg:px-5 py-5 transition-colors select-none">
      {/* Background blob */}
      <div
        className="absolute inset-x-0 -top-10 -z-10 transform-gpu overflow-hidden blur-3xl transition-all"
        aria-hidden="true"
      >
        <div
          className="relative right-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[10deg] bg-gradient-to-tl from-[#ff80b5] opacity-10 dark:opacity-15 sm:right-[calc(50%-30rem)] sm:w-[140.1875rem]"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        ></div>
      </div>

      <h2
        className="my-5 font-bold font-sans text-3xl md:text-4xl text-indigo-500 dark:text-white tracking-tight"
        id="projects"
      >
        Projects
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-6 gap-4 items-center justify-center transition-all">
        {ProjectsInfo.map((project, idx) => (
          <ScrollAnimatedItem
            key={project.title}
            custom={idx + 1}
            triggerOnce={true}
          >
            <div className="project-card border border-slate-300 dark:border-dashed dark:border-slate-700 rounded-md hover:shadow-sm dark:shadow-slate-800 transition-colors">
              <h2 className="font-semibold text-2xl leading-none tracking-tight py-5 text-center dark:text-zinc-200">
                {project.title}
              </h2>

              <div className="mx-5 border border-collapse rounded-md justify-center items-center bg-gradient-to-r from-[#ff80f9] to-[#9089fc] dark:from-[#f79be9e5] dark:to-[#a29bffe5]">
                <div className="m-7 rounded-md border shadow-sm flex flex-col transition ease-in-out hover:scale-105 duration-500 cursor-pointer grayscale-0">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="rounded-md"
                  />
                </div>
              </div>

              <div className="mx-5 py-3">
                <span className="font-medium text-slate-700 dark:text-slate-100 py-3">
                  {project.description}
                </span>
                <div className="flex flex-wrap items-center mt-3 mb-3">
                  {project.tech.map((tech) => (
                    <span
                      key={tech}
                      className="mr-3 lg:mr-5 my-2 bg-slate-200 font-medium hover:bg-slate-300 dark:bg-slate-800 dark:hover:bg-gray-900 dark:text-slate-100 rounded-md p-2 text-sm lg:text-sm tracking-wide"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="flex flex-wrap items-center">
                  <a
                    className="bg-slate-800 hover:bg-opacity-90 transition-all border dark:bg-slate-100 dark:text-black text-white rounded-md p-2 mr-4 text-sm lg:text-sm tracking-wide font-medium"
                    rel="noreferrer"
                    href={project.live}
                    target="_blank"
                  >
                    <i className="fa-solid fa-link mr-1"></i>Live Site
                  </a>
                  <a
                    className="bg-slate-200 hover:bg-slate-400 dark:bg-gray-800 dark:text-white dark:hover:bg-slate-700 text-black rounded-md p-2 text-sm lg:text-sm tracking-wide font-medium"
                    href={project.github}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <i className="fa-brands fa-github mr-1"></i>Github
                  </a>
                </div>
              </div>
            </div>
          </ScrollAnimatedItem>
        ))}
      </div>

      {/* Bottom blob */}
      <div
        className="absolute inset-x-0 -top-10 -z-10 transform-gpu overflow-hidden blur-3xl transition-all"
        aria-hidden="true"
      >
        <div
          className="relative right-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[45deg] bg-gradient-to-tl from-[#ff80b5] opacity-10 dark:opacity-15 sm:right-[calc(50%-30rem)] sm:w-[140.1875rem]"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Projects;
